<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-template-key -->
<template>
    <div>
        <block v-if="loading" />
        <div >
           

            <v-row :class="`mt-4 d-flex ${paddingXs}`">
                
              <!--   <v-col :cols="twoSlots ? 2 : 0" :md="!columns.length === 0 ? 6 : 10" :lg="!columns.length === 0 ? 6 : 10">
                  <v-row class="mt-2">
                    
                  </v-row>
                </v-col> -->
               
                

                <v-col cols="12" sm="12" md="2" lg="1" v-if="!oneDateFilter">
                    <v-checkbox v-if ="!disableDates"  v-model="enableDate"  @change="(e) => $emit('enabledate',e)" label="Filtrar Fecha" class="mx-2 pt-1"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="10" lg="5" v-if="!oneDateFilter">
                    <v-row class="date-row-responsive">
                        <v-col cols="12" sm="6" md="4" lg="4" class="date-col-responsive">
                            <date-picker  v-if ="!disableDates" :disbaled="!enableDate"  label="Fecha inicio" @dateSelected="(param) => {startDate = param; $emit('getStart', param) }" class="mx-1" />
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4" class="date-col-responsive">
                            <date-picker v-if ="!disableDates" :disbaled="!enableDate" label="Fecha fin" @dateSelected="(param) => {endDate = param; $emit('getEnd', param) }" class="mx-1" />
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="4" class="date-col-responsive d-flex align-center">
                            <v-btn @click="filterHandler();" v-if ="!disableDates" color="primary" :disabled="!enableDate" class="filter-btn-responsive">
                                <v-icon class="mr-1">mdi-filter</v-icon>
                                Filtrar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="10" lg="5" v-else>
                    <v-row class="date-row-responsive">
                        <v-col cols="12" sm="8" md="8" lg="8" class="date-col-responsive">
                            <date-picker  v-if ="!disableDates" label="A la fecha de" @dateSelected="(param) => {oneDate = param; $emit('getOneDate', param) }" class="mx-1" />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" class="date-col-responsive d-flex align-center">
                            <v-btn @click="filterHandler();" v-if ="!disableDates" color="primary" :disabled="!enableDate && !oneDateFilter" class="filter-btn-responsive">
                                <v-icon class="mr-1">mdi-filter</v-icon>
                                Filtrar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" class="p-1 ml-md-3" sm="12" md="8" lg="3" v-if="!hideSearchField">
                    <!--v-text-field outlined dense label="Buscar..." v-model="filter" @input="handleEmptyFilter" @keyup.enter="filterHandler"></v-text-field-->
                    <v-text-field outlined dense label="Buscar..." v-model="filter" @keyup.enter="filterHandler"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4" lg="2" class="d-flex justify-content-end action-buttons-responsive">
                            <v-btn v-if="!hideSearchField" ref="filterButton" class="btn-save mr-1" @click="filterHandler"><v-icon>mdi-magnify</v-icon></v-btn>
                            <v-btn
                                v-if="!advancedFilter && columnsSearch.length > 0"
                                class="btnBlack  mr-1"
                                style=""
                                @click="clearData"
                            >
                            <v-icon>
                                mdi-filter-remove
                            </v-icon>
                            </v-btn>
                            <v-btn
                            v-if="!advancedFilter && columnsSearch.length > 0"
                            class="btnclean mr-1"
                            @click="showDialog = true; ">
                                <v-icon>mdi-filter</v-icon>
                            </v-btn>

                            <!-- Slot para selector de sucursal -->
                <div style="margin-left: 20px;" v-if="$slots.branchSelector">
                    <slot name="branchSelector"></slot>
                </div>
                </v-col>
                <v-col v-if="advancedFilter" cols="12">
                    <GeneralFilterForm :columns.sync="columnsSearch" @onFilter="filterHandler()" @onClean="clearData">
                        <template v-slot:complementFilters>
                            <slot name="complementFilters"></slot>
                        </template>
                    </GeneralFilterForm>                    
                </v-col> 
            </v-row>
          
                
       <!--  <div v-for="(column, index) in columns" :key="index">

            
            <v-row>
                <v-col cols="12" md="3" :key="index">
                    <v-autocomplete
                        v-model="column.name"
                        label ="Columnas"
                        item-text="title"
                        item-value="name"
                        :items="columnAviable"
                        attach
                        @change="verifyColumn"
                    />
                </v-col>
              
            </v-row>
        </div> -->
                   
           
            
        </div>
        <div class="mt-4" >
            <div  :style="!isAutoScrolled && 'overflow-x:scroll;'">
                <slot>
    
                </slot>
            </div>
            <div v-if="!hideLimitLabel" class="d-flex justify-center mt-1 mb-2">
                <p>En la prevista se muestras los últimos 100 registros agregados</p>
            </div>
        </div>
        <v-dialog 
        v-if="!advancedFilter"
        scrollable
            v-model="showDialog"
            :max-width="dialogWidth"
        >
            <v-card>
                <v-card-title>
                    <h3>Filtros</h3>
                </v-card-title>
                <v-card-text>
                    <v-row v-if="radioSelect != []">
                        <v-radio-group v-model="selectedItem">
                            <v-row class="my-3">
                                <div v-for="(radio, index) in radioSelect" :key="index">
                                    <v-col cols="12" md="4" sm="6">
                                        <v-radio
                                            :label="radio.name"
                                            :value="radio.value"
                                        ></v-radio>
                                    </v-col>
                                </div>
 
                            </v-row>
                        </v-radio-group>
                    </v-row>
                    <v-row>
                        <v-col cols="6" >
                            <v-autocomplete
                                v-model="SelectedColumn"
                                label ="Seleccionar Columna"
                                item-text="title"
                                item-value="name"
                                :items="columnAviable"
                                outlined
                                dense
                                @change="verifyColumn"
                            />
                        </v-col>
                        <v-col cols="3" >
                            <v-btn
                                class="btn-save"
                                @click="handleColumn"
                        
                            >Añadir Columna</v-btn>
                        </v-col>
                        <v-col col="3" style="margin-bottom: 25px;" >
                            <v-btn
                                class="btnclean"
                                @click="columns = []"
                        
                            >Quitar columnas</v-btn>
                        </v-col>
                    </v-row>
                    
                    
                        <v-row v-for="(column, index) in columns"  :key="index"   >
                            <v-col cols="10" >
                                <template v-if="column.type == 'select'">
                                    <v-select
                                        v-model="column.value"
                                        :items="column.options"
                                        item-text="name"
                                        item-value="value"
                                        
                                        @change="filterOptions(column)"
                                        outlined dense
                                        :label="column.title"
                                    />
                            
                                </template>
                                <template v-else>
                                    <v-text-field
                                    v-model="column.value"
                                    outlined dense
                                    :label="column.title"
                                    />
                            
                                </template>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    class="btndelete"
                                    @click="columns.splice(index,1); filterOptions()"
                            
                                ><v-icon>mdi-close</v-icon></v-btn>
                            </v-col>
                        </v-row>
                   
                </v-card-text>
                <v-card-actions class="d-flex justify-space-between">
                    <v-btn class="btndelete" @click="showDialog = false">Cerrar</v-btn>
                    <v-btn class="btn-save" @click="showDialog = false; filterHandler()">Filtrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import DatePicker from '@/components/DatePicker'
import GeneralFilterForm from './GeneralFilterForm.vue'


    export default {
        name: 'VersatileFilter',
        components: { DatePicker, GeneralFilterForm },
        props: {
            advancedFilter: {
                type: Boolean,
                default: false
            },
            filterEndpoint: {
                type: Function,
                default: null
            },
            search: {
                type: Object,
                default: null
            },
            requiredParams: {
                type: Boolean,
                default: false
            },
            hideLimitLabel: {
                type: Boolean,
                default: false
            },
            disableDates: {
                type: Boolean,
                default: false
            },
            isAutoScrolled: {
                type: Boolean,
                default: false
            },
            twoSlots: {
                type: Boolean,
                default: false
            },
            columnsSearch: {
                type: Array,
                default: function(){
                    return []
                }
            },
            useCache: {
                type: Boolean,
                default: false
            },
            

            columnfilterEndpoint: {
                type: Function,
                default: null
            },
            radioSelect: {
                type: Array,
                default: function(){
                    return []
                }
            },
            defaulSelect: {
                type: String,
                default: null
            },
            extraParam1: {
                type: String,
                default: null
            },
            extraParam2: {
                type: String,
                default: null
            },
            oneDateFilter: {
                type: Boolean,
                default: false
            },
            oNoStockRecords: {
                type: Boolean,
                default: false
            },
            hideSearchField: {
                type: Boolean,
                default: false
            },
            enableDateStatus: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                filter: null,
                columns: [],
                limit: 0,
                SelectedColumn: {},
                showDialog: false,
                loading: false,
                startDate: null,
                endDate: null,
                oneDate: null,
                sourceFormat: "dd/mm/yyyy",
                targetFormat: "yyyy-mm-dd",
                enableDate: this.enableDateStatus,
                selectedItem:  this.defaulSelect,
            }
        },
        mounted() {
            this.limit = this.columnsSearch.length;
            this.columns = this.columnsSearch;
        },
        computed: {
            dialogWidth() {
                return this.$vuetify.breakpoint.smAndDown ? "95%" : "40%";
            },
            paddingXs(){
                return this.$vuetify.breakpoint.smAndDown ? 'px-2' : '';
            },
            columnAviable() {
                return this.columnsSearch.filter((column) => {
                    return !this.columns.some((columnAdded) => {
                        return column.name === columnAdded.name;
                    });
                });
            },
            calculateColSize() {
        
                if (this.$vuetify.breakpoint.xsOnly) {
                    return 12;
                } else {
                    
                    return this.twoSlots ? 5 : 7
                }
            }
            
        },
        watch: {
            columnsSearch(newVal) {
               this.columns = newVal;
            },
            columns(){
                if(this.columns.length === 0){

                    if(!this.requiredParams)
                       this.$emit('emptyFilter');
                    else
                        this.filterHandler();
                }
            }
        },
        methods: {
           
            filterOptions(changued = null){
                if(changued){
                    const child = this.columns.find((column) => column.parent == changued.name);
                    if(child){
                        this.columns.forEach((column) => {
                            if(column.parent == child.name){
                                if(column.prev === undefined)
                                column.prev = column.options;
                                column.value = '';
                                column.options = column.prev.filter((option) => option.parent_id == child.value);
                            }
                        })
                    }
                }
                this.columns.forEach((column) => {
                    if(column.parent){
                       const parentCol = this.columns.find((col) => col.name == column.parent);
                       if(parentCol && parentCol.parent){
                           const grandParent = this.columns.find((col) => col.name == parentCol.parent);
                            if(grandParent){
                                if(column.prev === undefined){
                                column.prev = column.options;
                            }
                            column.options = column.prev.filter((option) => option.parent_id == parentCol.value);
                            }
                            
                       }
                       if(parentCol ){
                            if(column.prev === undefined){
                                column.prev = column.options;
                            }
                            column.options = column.prev.filter((option) => option.parent_id == parentCol.value);
                            
                       }
                       else{
                            if(column.prev != undefined){
                                column.options = column.prev;
                            }
                       }
                       
                
                    }
                })
            },
            
            verifyColumn(e){
                console.log('verificando',e);
                //verificar si la columna ya esta agregada
                let counter = 0;
                this.columns.forEach((column) => {
                    if(column.name == e){
                        counter++;
                        
                    }
                })
                if(counter > 1){
                    //eliminar la columna repetida
                    this.columns.forEach((column,index) => {
                        if(column.name == e){
                            this.columns.splice(index,1);
                        }
                    })
                    //this.$toast.error('La columna ya esta agregada');
                }
            },
            clearData() {
                console.log('limpiando');
                this.filter = '';
                this.columns = this.columns.map((column) => {
                    column.value = '';
                    return column;
                });
                this.selectedItem = this.defaulSelect;
                this.enableDate = this.enableDateStatus;
                 if(!this.requiredParams)
                       this.$emit('emptyFilter');
                    else
                        this.filterHandler();
            },
            handleEmptyFilter() {
                this.$emit( 'setTypedFilter', this.filter );
                if(this.filter.length === 0) {
                    if(!this.requiredParams)
                       this.$emit('emptyFilter');
                    else
                        this.filterHandler();
                }
            },
          /*   filterHandler() {
                console.log('filtrando');
                if(this.filter?.length != 0 && this.filter) {
                    console.log('filtrando',this.search);
                    this.search.filter = this.filter
                    this.filterEndpoint(this.search)
                        .then(response => {
                            console.log('filtrado', response);
                        this.$emit('filtered', response);
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                    this.$emit('emptyFilter');
                }
            }, */
            filterHandler() {
                this.loading = true;
                const columnsSend = JSON.stringify(
                    this.columns
                        .filter(column => !!column.value || column.value !== '' )
                        .map((column) => ({
                        name: column.name,
                        value: column.value,
                        type: column.type
                    }))
                );

                this.$emit( 'sendColumnsToSend', columnsSend )

                let dates = {};
                if(this.oneDateFilter) {
                    dates = {
                        oneDate: this.oneDate
                    }

                    this.$emit( 'setDatesToSend', dates );
                } else if(this.enableDate){
                    dates = {
                        startDate: this.startDate,
                        endDate: this.endDate
                    }
                    this.$emit( 'setDatesToSend', dates );
                }

                this.$emit('updateCache',{filter : columnsSend,business: this.search.business, branch: this.search.branch, search: JSON.stringify(this.search),
                    like: this.filter, selectedItem: this.radioSelect != [] ? this.selectedItem : null,
                    dates: JSON.stringify(dates), hideNoStockRecords: this.oNoStockRecords });
                this.columnfilterEndpoint({extraParam1: this.extraParam1, extraParam2: this.extraParam2, filter : columnsSend,business: this.search.business, branch: this.search.branch, search: JSON.stringify(this.search),
                    like: this.filter, selectedItem: this.radioSelect != [] ? this.selectedItem : null,
                    dates: JSON.stringify(dates), hideNoStockRecords: this.oNoStockRecords 
                })
                    .then(response => {
                        this.loading = false;
                        console.log( 'despues de filtrar' );
                    this.$emit('filtered', response);
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                });
               
            },
            handleColumn(){
               
                
                const column = this.columnsSearch.find((column) => column.name == this.SelectedColumn);
                
                if(this.limit < this.columns.length){
                    return;
                }
                if(column){
                    
                    this.columns.find((column) => column.name == this.SelectedColumn) ? '' : this.columns.push(column);
                }
                this.filterOptions();
                
            }
        }
    }

</script>

<style scoped>
.btnBlack {
  background-color: rgba(60, 60, 60) !important;
  color: white;
}

.orderedBeside {
  padding-top: 16px;
}

/* Estilos responsive para fechas */
.date-row-responsive {
  margin: 0;
}

.date-col-responsive {
  padding: 4px 8px;
}

.filter-btn-responsive {
  width: 100%;
  min-width: auto;
}

/* Media queries para dispositivos móviles */
@media (max-width: 600px) {
  .date-col-responsive {
    padding: 2px 4px;
  }
  
  .filter-btn-responsive {
    margin-top: 8px;
    font-size: 0.875rem;
  }
  
  .date-row-responsive .v-col {
    flex-basis: 100%;
    max-width: 100%;
  }
  
  .action-buttons-responsive {
    justify-content: center !important;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .action-buttons-responsive .v-btn {
    margin: 2px;
    min-width: 40px;
  }
}

@media (max-width: 960px) and (min-width: 601px) {
  .date-col-responsive {
    padding: 3px 6px;
  }
  
  .action-buttons-responsive {
    justify-content: center !important;
  }
}
</style>